import PageStyle from "@/styles/pages/errors/_index.module.scss";
import Image from 'next/image';

export default function Error429(){
    return (

    <div className={`${PageStyle.NewJob}`}>
      <div className={PageStyle.NewJob__Container}>
        <div className={PageStyle.Error}>
          <Image src='/images/errors/500.png' height={153} width={293} alt=''></Image>

          <h1>429</h1>

          <h3>{t("errors:too_many_requests")}</h3>
        </div>
      </div>
    </div>
    )
}
